import type { TFunction } from 'i18next';

interface EmptyStateText {
  title: string;
  description: string;
}

/** NB: [assignedToMe] only has an effect when [fetchMode] === 'list'. */
export function getChecklistEmptyStateText(
  t: TFunction,
  fetchMode: 'search' | 'list',
  assignedToMe: boolean
): EmptyStateText {
  if (fetchMode === 'search') {
    return {
      title: t('noActivitiesMatchingSearchTitle', 'No results'),
      description: t(
        'noActivitiesMatchingSearchDescription',
        'Try adjusting your search query or filters'
      ),
    };
  } else if (assignedToMe) {
    return {
      title: t('noActivitiesMatchingFilterTitle', 'No checklists yet'),
      description: t(
        'noActivitiesAssignedToMeDescription',
        'Once checklists are assigned to you, they will appear here'
      ),
    };
  } else {
    return {
      title: t('noActivitiesMatchingSearchTitle', 'No results'),
      description: t(
        'noActivitiesMatchingFilter',
        'No activities match your current filter'
      ),
    };
  }
}
